//@ts-nocheck
import React, { useState, useRef, useEffect } from "react";
import { Button } from "@factorearth/component-library";
import Textarea from "react-textarea-autosize";
import styles from "./MadLib.module.scss";

function MadLib(props) {
	const { color, actionElement, optionData, index, handleSubmit, value } = props;

	// ONE THING TO NOTE FOR THESE GETTING SETUP
	const [currentValue, setCurrentValue] = useState(value);
	const [delim, setDelim] = useState(setupDelim(actionElement));
	const [savedValue, setSavedValue] = useState(value);
	const [cursorPos, setCursorPos] = useState(null);
	const [selectedDropdownIndex, setSelectedDropdownIndex] = useState(() => {
		const noneIdx = optionData?.findIndex((o) => o.id === "NONE");
		return noneIdx >= 0 ? noneIdx : 0;
	});
	const ref = useRef(null);

	function setupDelim(actionElement) {
		let delimiter = actionElement.delimiter;
		if (delimiter.includes("CHARCODE")) {
			// This type of delimiter always needs _
			const charCode = delimiter.split("_")[1];
			delimiter = String.fromCharCode(charCode);
		} else if (delimiter.includes("EMBED")) {
			// This is a special type of delimiter that actually embeds the requirements into the text rather than using a specific character to split on. This will require special handling in the code and will likely be setup differently in the action element configuration.
			// For now we can just return the whole thing and handle it in the code as a special case, but eventually we may want to setup a specific way to designate what is embedded in the text and how to organize it.
			delimiter = actionElement.delimiter;
		}

		// VVV INSERT OTHER SPECIAL DELIMITER LOGIC HERE VVV
		return delimiter;
	}

	function handleChange(e) {
		const { value, selectionStart } = e.target;
		setCursorPos(selectionStart);
		setCurrentValue(value);
		setSavedValue(value);
		setCursorPos(selectionStart);
	}

	/**
	 * OnBlur handler to save the last cursor position before clicking the dropdown.
	 * @param {event} e from the input that was just blurred from.
	 */
	function onBlur(e) {
		setCursorPos(e.target.selectionStart);
	}

	const handleOptionChange = (index) => {
		const option = optionData[index];
		// Always reset dropdown back to NONE after a selection
		const noneIdx = optionData?.findIndex((o) => o.id === "NONE");
		setSelectedDropdownIndex(noneIdx >= 0 ? noneIdx : 0);
		if (option.id === "NONE") {
			// This is the option for none, which just inserts nothing and is basically a way to exit out of the madlib without having to delete the text that was inserted.
			setSavedValue(currentValue);
			return;
		}
		// Need to handle a DOM version and non-DOM version here

		// May use this again! - potentially could setup the dom version here.. At this point
		// it is not high enough priority to spend time based on how complex it could be, but will be
		// a fun one one day!

		if (delim === "EMBED") {
			// This is the special case for the EMBED type delimiter, which actually embeds the requirement into the text rather than using a specific character to split on. This will require special handling in the code and will likely be setup differently in the action element configuration.
			// For now we can just insert the option header directly into the text at the cursor position, but eventually we may want to setup a specific way to designate what is embedded in the text and how to organize it.
			setSavedValue(currentValue.slice(0, cursorPos) + "${" + option.id + "}" + currentValue.slice(cursorPos));
			setCurrentValue(currentValue.slice(0, cursorPos) + "${" + option.id + "}" + currentValue.slice(cursorPos));
		} else {
			// setCurrentValue(currentValue.slice(0, cursorPos) + `<VALUE FROM: ${option.header} FIELD>` + currentValue.slice(cursorPos));
			setSavedValue(currentValue.slice(0, cursorPos) + delim + option.header + delim + currentValue.slice(cursorPos));
			setCurrentValue(currentValue.slice(0, cursorPos) + delim + option.header + delim + currentValue.slice(cursorPos));
		}
	};

	/**
	 * this guy sets up the dropdown options from the props
	 */
	function setupOptions() {
		const html = [];
		for (let i = 0; i < optionData.length; i++) {
			const data = optionData[i];
			const option = (
				<option key={data.id} id={data.id} value={i}>
					{data.header}
				</option>
			);

			html.push(option);
		}

		return html;
	}

	function handleSubmitMadLib() {
		handleSubmit(savedValue, index);
	}

	return (
		<div>
			<Textarea
				style={{
					backgroundColor: color.background.secondary,
					border: `${color.border.primary} 1px solid `,
					color: color.text.primary,
				}}
				ref={ref}
				type="textarea"
				id={`madlib-${index}`}
				key={`madlib-${index}`}
				className={styles.input}
				placeholder={`Madlib time!`}
				defaultValue={currentValue}
				value={currentValue}
				onChange={handleChange}
				onBlur={onBlur}
				// maxRows={fromTable ? 10 : null}
			/>
			<select value={selectedDropdownIndex} onChange={(e) => handleOptionChange(e.target.value)}>
				{setupOptions()}
			</select>
			<Button colorPalette={color} onClick={handleSubmitMadLib}>
				Submit
			</Button>
		</div>
	);
}

export default MadLib;
